module.exports = __webpack_public_path__ + "img/end.b7d29d04.svg";